"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var TileDoctype_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileDoctype = exports.DOCTYPE_NAME = void 0;
const fast_json_patch_1 = __importDefault(require("fast-json-patch"));
const base64_1 = require("@ethersproject/base64");
const random_1 = require("@ethersproject/random");
const common_1 = require("@ceramicnetwork/common");
exports.DOCTYPE_NAME = 'tile';
let TileDoctype = TileDoctype_1 = class TileDoctype extends common_1.Doctype {
    async change(params, opts = {}) {
        var _a, _b;
        if (this.context.did == null) {
            throw new Error('No DID authenticated');
        }
        const updateCommit = await TileDoctype_1._makeCommit(this, this.context.did, params.content, (_a = params.metadata) === null || _a === void 0 ? void 0 : _a.controllers, (_b = params.metadata) === null || _b === void 0 ? void 0 : _b.schema);
        const updated = await this.context.api.applyCommit(this.id.toString(), updateCommit, opts);
        this.state = updated.state;
    }
    static async create(params, context, opts) {
        const { content, metadata } = params;
        const commit = await TileDoctype_1.makeGenesis({ content, metadata }, context);
        return context.api.createDocumentFromGenesis(exports.DOCTYPE_NAME, commit, opts);
    }
    static async makeGenesis(params, context) {
        const unique = params.deterministic ? '0' : base64_1.encode(random_1.randomBytes(12));
        const metadata = params.metadata || { controllers: [] };
        if (!metadata.controllers || metadata.controllers.length === 0) {
            if (params.content && context.did) {
                metadata.controllers = [context.did.id];
            }
            else {
                throw new Error('No controllers specified');
            }
        }
        if (metadata.controllers.length !== 1) {
            throw new Error('Exactly one controller must be specified');
        }
        const commit = { data: params.content, header: metadata, unique };
        return (params.content ? await TileDoctype_1._signDagJWS(commit, context.did, metadata.controllers[0]) : commit);
    }
    static async _makeCommit(doctype, did, newContent, newControllers, schema) {
        const header = {
            ...schema != null && { schema: schema },
            ...newControllers != null && { controllers: newControllers },
        };
        if (newContent == null) {
            newContent = doctype.content;
        }
        if (header.controllers && header.controllers.length !== 1) {
            throw new Error('Exactly one controller must be specified');
        }
        const patch = fast_json_patch_1.default.compare(doctype.content, newContent);
        const commit = { header, data: patch, prev: doctype.tip, id: doctype.state.log[0].cid };
        return TileDoctype_1._signDagJWS(commit, did, doctype.controllers[0]);
    }
    static async _signDagJWS(commit, did, controller) {
        if (did == null || !did.authenticated) {
            throw new Error('No DID authenticated');
        }
        return did.createDagJWS(commit, { did: controller });
    }
};
TileDoctype = TileDoctype_1 = __decorate([
    common_1.DoctypeStatic()
], TileDoctype);
exports.TileDoctype = TileDoctype;
//# sourceMappingURL=tile-doctype.js.map